export default container => {
  const buttons = container.querySelectorAll('[data-button]')

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          buttons.forEach(button => {
            button.classList.remove('button-mini__container--show')
            button.classList.add('button-mini__container--hide')
          })
        }, 0)
      }
    })
  })

  container.querySelectorAll('[data-hide-button], .hero').forEach(section => {
    observer.observe(section)
  })
}
